export default __webpack_public_path__ + "static/media/0x2b9e7ccdf0f4e5b24757c1e1a80e311e34cb10c7.ed5270e9.webp";